import createIcon from '../../createIcon';

/**
 * @component @name East
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgNUwxMy41OSA2LjQxTDE4LjE3IDExSDJWMTNIMTguMTdMMTMuNTggMTcuNTlMMTUgMTlMMjIgMTJMMTUgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const East = createIcon('East', [
  [
    'path',
    { d: 'M15 5L13.59 6.41L18.17 11H2V13H18.17L13.58 17.59L15 19L22 12L15 5Z', key: 'utvh8i' },
  ],
]);

export default East;
